import React, { useEffect, useState } from 'react';
import './Home.scss';
import { motion, AnimatePresence } from 'framer-motion';
import { pageTransitions } from '../../animations';

const Home = (props) => {
  useEffect(() => {
    props.setDarkenNavbar(false);
  });
  return (
    <motion.div
      className="Home-Page"
      variants={pageTransitions}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <div className="Home-Page__My-details">
        <div className="Home-Page__My-details__Name">ANKUR SAHA</div>
        <div className="Home-Page__My-details__Details">
          Developer | Student | Programmer
        </div>
      </div>
    </motion.div>
  );
};
export default Home;
